<ces-error-page [code]="'pages.errors.403.title' | transloco" [heading]="'pages.errors.403.subtitle' | transloco" [showBack]="true">
  <p class="text-(color:--text-secondary)">{{ 'pages.errors.403.message' | transloco }}</p>

  @if (debugInfo(); as info) {
    <div
      class="mt-(--space-6) w-full rounded-(--radius-lg) border border-(--border) bg-(--surface-2) p-(--padding-card) text-left text-sm">
      <h2 class="mb-(--space-2) font-semibold text-(color:--text-primary)">{{ 'pages.errors.403.technicalInfo' | transloco }}</h2>
      <dl class="grid grid-cols-[auto_1fr] gap-x-(--space-3) gap-y-(--space-1) text-(color:--text-secondary)">
        @if (info.route) {
          <dt class="font-semibold">{{ 'pages.errors.403.blockedRoute' | transloco }}</dt>
          <dd>{{ info.route }}</dd>
        }
        @if (info.userId) {
          <dt class="font-semibold">{{ 'pages.errors.403.user' | transloco }}</dt>
          <dd>ID {{ info.userId }}</dd>
        }
        @if (info.assetId) {
          <dt class="font-semibold">{{ 'pages.errors.403.asset' | transloco }}</dt>
          <dd>ID {{ info.assetId }}</dd>
        }
        @if (info.reason) {
          <dt class="font-semibold">{{ 'pages.errors.403.reason' | transloco }}</dt>
          <dd>{{ info.reason }}</dd>
        }
      </dl>
    </div>
  }
</ces-error-page>
